<template>
  <b-container fluid class="container-menu">
    <b-row>
      <b-col class="col-12 px-0">
        <b-navbar toggleable="md" type="light">
          <b-navbar-toggle target="nav-collapse" class="btn-toggle py-3">
            <template>
              <b-img src="/img/ico_menu_mobile.png" fluid alt="Logo"></b-img>
            </template>
          </b-navbar-toggle>
          <b-navbar-brand href="/" class="d-none d-md-block">
            <b-img src="/img/logo.png" fluid alt="Logo"></b-img>
          </b-navbar-brand>

          <b-collapse id="nav-collapse" is-nav class="mt-3">
            <b-navbar-nav class="ml-auto">
              <b-nav-item href="http://www.finlev.com.br/">Inicial</b-nav-item>
              <b-nav-item href="http://www.finlev.com.br/index/afinlev"
                >A Finlev</b-nav-item
              >
              <b-nav-item href="http://www.finlev.com.br/index/solucoes"
                >Soluções</b-nav-item
              >
              <b-nav-item href="http://www.finlev.com.br/index/simule"
                >Simule seu Crédito</b-nav-item
              >
              <b-nav-item href="http://www.finlev.com.br/index/duvidas"
                >Dúvidas</b-nav-item
              >
              <b-nav-item
                href="http://www.finlev.com.br/index/login"
                class="btn-green-1"
                >ENTRAR</b-nav-item
              >
            </b-navbar-nav>
          </b-collapse>
          <b-navbar-brand href="/" class="d-md-none pt-5 pb-3">
            <b-img src="/img/logo_branca.png" fluid alt="Logo"></b-img>
          </b-navbar-brand>
        </b-navbar>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "Menu",
};
</script>

<style>
#nav-collapse a {
  font-size: 18px;
  color: #396477;
  font-weight: 500;
}

.btn-green-1 a {
  background-color: #63c29d;
  color: white !important;
  border-radius: 15px;
  border: dashed 1px #cfd7d7;
  font-weight: 500;
  padding: 5px 20px !important;
}

@media (max-width: 767px) {
  .btn-green-1 {
    text-align: center;
  }

  .btn-toggle {
    display: block;
    width: 100%;
    text-align: left;
    padding: 0px !important;
  }

  .navbar-light .navbar-toggler {
    border-color: transparent !important;
  }

  .btn-toggle img {
    max-width: 50px;
  }

  #nav-collapse {
    background-color: white;
    border-radius: 5px;
    padding: 15px;
  }
}

@media (min-width: 768px) {
  #nav-collapse .nav-item {
    padding-left: 0px;
    padding-top: 10px;
  }

  .navbar-brand img {
    max-width: 150px;
  }

  #nav-collapse a {
    font-size: 16px;
  }
  .container-menu {
    background-color: white;
  }
}

@media (min-width: 992px) {
  #nav-collapse a {
    font-size: 18px;
  }

  .navbar-brand img {
    max-width: 200px;
  }

  #nav-collapse .nav-item {
    padding-left: 10px;
    padding-top: 10px;
  }
}

@media (min-width: 1200px) {
  .navbar-brand img {
    max-width: 300px;
  }

  #nav-collapse .nav-item {
    padding-right: 20px;
    padding-top: 20px;
  }

  .container-fluid,
  #navbar-container {
    padding-left: 50px;
    padding-right: 50px;
  }
}
</style>